import React from 'react';
import { useNavigate } from 'react-router-dom';
import {WritingBigIcon} from '../../../assets';
import { ArrowLeft } from 'lucide-react';

const WritingPreviewPage = () => {
  const navigate = useNavigate();

  const handleBackToIELTSTest = () => {
    navigate('/IELTSTest'); // Arahkan ke halaman utama IELTS Test
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-[#E0E7FF] to-white py-6 px-4 sm:py-8 md:py-12 lg:py-16 flex items-center justify-center">
      <div className="w-full max-w-6xl mx-auto">
        {/* Card Utama */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl lg:shadow-2xl overflow-hidden flex flex-col md:flex-row min-h-[400px] md:min-h-[450px] lg:min-h-[500px]">
          
          {/* === BAGIAN KIRI: Info Belum Tersedia === */}
          <div className="bg-gradient-to-r from-[#1e3e7e] to-[#a51c30] p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 flex flex-col justify-between text-white w-full md:w-1/2">
            <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl font-bold font-poppins">
                WRITING TEST
              </h2>

              {/* Info Belum Tersedia */}
              <div className="bg-red-500 bg-opacity-80 backdrop-blur-sm p-3 sm:p-4 md:p-5 rounded-lg text-xs sm:text-sm md:text-base lg:text-lg font-roboto">
                <p className="font-semibold mb-2 text-yellow-300">Sedang Dalam Pengembangan</p>
                <p className="leading-tight">
                  Kategori <strong>Writing Test</strong> belum tersedia saat ini. 
                  Kami sedang bekerja keras untuk menyiapkan simulasi audio berkualitas tinggi.
                </p>
              </div>

              <p className="text-xs sm:text-sm md:text-base lg:text-lg font-roboto opacity-80">
                Silakan coba kategori lain yang sudah tersedia:
              </p>

              <ul className="text-[10px] xs:text-xs sm:text-xs md:text-sm lg:text-sm font-roboto space-y-1 list-disc list-inside opacity-90">
                <li>Reading Test</li>
              </ul>
            </div>

            {/* Tombol Kembali ke IELTS Test */}
            <button
              onClick={handleBackToIELTSTest}
              className="mt-4 sm:mt-6 md:mt-8 lg:mt-10 bg-transparent border-2 border-white text-white font-poppins font-semibold text-xs sm:text-sm md:text-base lg:text-lg px-4 sm:px-5 md:px-6 lg:px-7 py-2 sm:py-2.5 md:py-3 rounded-full hover:bg-white hover:text-[#1e3e7e] transition flex items-center gap-1.5 sm:gap-2 w-fit"
            >
              <ArrowLeft size={16} className="sm:size-5 md:size-6 lg:size-6" />
              Kembali
            </button>
          </div>

          {/* === BAGIAN KANAN: Preview Icon === */}
          <div className="bg-white p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 flex flex-col justify-between text-center w-full md:w-1/2">
            
            {/* Judul + Icon + Pesan */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-8 flex-1 flex flex-col justify-center items-center">
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl font-bold text-[#1e3e7e] font-poppins">
                WRITING TEST
              </h1>

              {/* Icon Headphone – Muncul Jelas */}
              <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-40 lg:h-40 xl:w-48 xl:h-48 bg-none flex items-center justify-center p-3 sm:p-4 md:p-5 lg:p-6">
                <img
                  src={WritingBigIcon}
                  alt="Writing Icon"
                  className="w-full h-full object-contain"
                />
              </div>

              <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-gray-600 font-roboto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg leading-relaxed">
                Fitur ini akan segera hadir. Pantau terus update kami!
              </p>
            </div>

            {/* Tombol Kembali (Duplikat di kanan bawah) */}
            <div className="flex justify-end mt-4 sm:mt-6 md:mt-8 lg:mt-10">
              <button
                onClick={handleBackToIELTSTest}
                className="bg-yellow-400 text-[#1e3e7e] font-poppins font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl px-5 sm:px-6 md:px-7 lg:px-8 py-2 sm:py-2.5 md:py-3 lg:py-3.5 rounded-full hover:bg-yellow-500 transition shadow-md"
              >
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WritingPreviewPage;